// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Recursos por namespace "common"
import esCommon from "../locales/es/common.json";
import enCommon from "../locales/en/common.json";

// Mapea variantes a códigos base (en-US -> en)
export const normalizeLang = (lng = "") => (lng || "").split("-")[0] || "es";

// ─── Mapas nombre <-> código para usar en formularios y guardado ───
export const LANG_NAME_TO_CODE = {
  Español: "es",
  English: "en",
};

export const LANG_CODE_TO_NAME = {
  es: "Español",
  en: "English",
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "es",
    // toma primero lo que tengas persistido, normalizado
    lng: normalizeLang(localStorage.getItem("app:lang") || undefined),
    resources: {
      es: { common: esCommon },
      en: { common: enCommon },
    },
    ns: ["common"],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      // orden de detección
      order: ["localStorage", "navigator", "htmlTag"],
      // clave personalizada que ya estás usando
      lookupLocalStorage: "app:lang",
      caches: ["localStorage"], // permitir que cachee
    },
    react: {
      useSuspense: false, // como lo estás usando en tu app
    },
  });

// ─── Forzamos a que siempre persista en la misma clave personalizada ───
i18n.on("languageChanged", (lng) => {
  // Guardar el código simple (es/en)
  const code = normalizeLang(lng);
  try {
    localStorage.setItem("app:lang", code);
  } catch {}
});

export default i18n;
